export const ALTURA_CARTAO_ESTIMADA = 96;
export const LIMIAR_VIRTUALIZACAO = 200;

export function alternarColapso(conjunto: Set<string>, id: string): Set<string> {
  const novoConjunto = new Set(conjunto);
  if (novoConjunto.has(id)) {
    novoConjunto.delete(id);
  } else {
    novoConjunto.add(id);
  }
  return novoConjunto;
}

export function larguraColuna({ recolhida }: { recolhida: boolean }): string {
  return recolhida ? 'w-12' : 'min-w-[16rem] flex-1';
}

export function deveVirtualizar(quantidade: number): boolean {
  return quantidade > LIMIAR_VIRTUALIZACAO;
}

export function rotuloAguardandoAlocacao(quantidade: number): string {
  if (quantidade === 0) return 'Nenhum cartão aguardando alocação.';
  if (quantidade === 1) return '1 cartão aguardando alocação';
  return `${quantidade} cartões aguardando alocação`;
}

export function rotuloJanelaConcluido(dias: number | null): string {
  if (dias === null) return 'Mostrando todos';
  return `Mostrando os últimos ${dias} dias`;
}
